import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import { unloadProject } from '../../modules/projectModule/project';
import { unloadOrder, viewOrder } from '../../modules/projectModule/order';
import { viewProject } from '../../modules/projectModule/project';
import OrderBookApprovalContainer from '../projectmng/obtainorder/OrderBookApprovalContainer';
import OrderBookInfoContainer from '../projectmng/obtainorder/OrderBookInfoContainer';
import OrderProductListContainer from '../projectmng/obtainorder/OrderProductListContainer';

//import OrderBillListContainer from '../projectmng/obtainorder/OrderTaxBillIssued';


import ApprovalFormContainer from './ApprovalFormContainer';
import SalesProfitInfoContainer from '../projectmng/obtainorder/SalesProfitInfoContainer';
import ApprovalSummary from '../../components/approval/ApprovalSummary';

//import OrderCompanyBillListContainer from '../../../containers/chancemng/obtainorder/OrderCompanyBillListContainer';
import OrderCompanyBillListContainer from '../../containers/chancemng/obtainorder/OrderCompanyBillListContainer';

const ApprovalOrderViewContainer = ({ id }) => {
  const dispatch = useDispatch();
  const { project, user, receiveOrderInf, approval, approvalList, loading } =
    useSelector(({ auth, projectModule, userModule, loading }) => ({
      user: auth.user,
      approval: userModule.approval.approval,
      project: projectModule.project.project,
      receiveOrderInf: projectModule.order.receiveOrderInf,
      billInfList: projectModule.order.billInfList,
      billInvList: projectModule.order.billInvList,
      approvalList: projectModule.order.approvalList,
      message: projectModule.order.message,
      error: projectModule.order.error,
      loading: loading['project/VIEW_ORDER'],
    }));

  useEffect(() => {
    if (id) {
      dispatch(viewOrder(id));
    }

    return () => {
      unloadOrder();
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (receiveOrderInf) {
      dispatch(viewProject(receiveOrderInf.prjUuid));
    }

    return () => {
      unloadProject();
    };
  }, [dispatch, receiveOrderInf]);

  if (loading || !receiveOrderInf || !project) {
    return null;
  }

  return (
    <>
      {receiveOrderInf && receiveOrderInf?.ordYn === 'S' && (
        <ApprovalFormContainer
          docuCd={receiveOrderInf?.roUuid}
          user={user}
          type="order"
        />
      )}

      {/* <DetailTemplate title="개요">
        <OrderBookSummary
          orderInfo={receiveOrderInf}
          approvalList={approvalList}
        />
      </DetailTemplate> */}
      <DetailTemplate title="개요">
        <ApprovalSummary info={approval} />
      </DetailTemplate>
      {approval?.docuTxt && approval?.docuTxt !== '' && (
        <DetailTemplate title="결재 참고사항">
          <Box>
            <Typography variant="body2" component="div">
              {approval?.docuTxt}
            </Typography>
          </Box>
        </DetailTemplate>
      )}

      <DetailTemplate title="상세내역">
        <OrderBookInfoContainer
          orderInfo={receiveOrderInf}
          project={project}
          isLink
        />
      </DetailTemplate>

      <DetailTemplate title="최종 매출 이익 (내부거래 포함)">
        <SalesProfitInfoContainer
          orderInfo={receiveOrderInf}
          project={project}
        />
      </DetailTemplate>

      <DetailTemplate title="결재 내역">
        <OrderBookApprovalContainer approvalList={approvalList} />
      </DetailTemplate>

      <DetailTemplate title="거래처별 매출/매입 내역">
        <OrderCompanyBillListContainer 
          chance={project} 
          roUuid={receiveOrderInf?.roUuid ? receiveOrderInf?.roUuid : null} 
          mode='view'
        />
      </DetailTemplate>


    </>
  );
};

export default ApprovalOrderViewContainer;
